import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/learnManage',
        name: '学习课堂',
        meta: {
            title: "学习课堂",
        },
        redirect: '/learnManage/learnList',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/learnManage/learnList',
                name: "学习列表",
                meta: {
                    title: "学习列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/learnManage/learnList.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]